// Mock data for Paws in the Park 2026 Event

export const eventInfo = {
  name: "Paws in the Park 2026",
  date: "2026-09-06",
  location: "Warwick Daniels Lake View Park",
  host: "Twin Waters Resident's Association (TWRA)",
  theme: "Paws of Purpose: Celebrating Dogs Who Give to our Community",
  subtitle: "Loyal Companions. Brave Protectors. Everyday Heroes.",
  budget: 1750
};

export const committee = [
  { name: "Amanda Abbott" },
  { name: "Carina Bertoldi" },
  { name: "Cassandra Turner" },
  { name: "Joanne Reilly" },
  { name: "Martin Haase" },
  { name: "Mary Earnshaw" },
  { name: "Naomi McQueen" },
  { name: "Sarah Tallis" },
  { name: "Tami Haase" }
];

export const logistics = {
  soundSystem: { provider: "QUEvents", cost: 750 },
  toilets: { provider: "JC Hire", cost: 350 },
  fencing: { provider: "Airport Crowd Control", cost: 0 },
  transport: { provider: "LJ Hooker Ute", cost: 0 }
};

export const serviceGroups = [
  {
    id: 1,
    name: "Story Dogs",
    description: "Helping children improve their reading skills through the companionship of dogs",
    fullDescription: "Story Dog is a fantastic national companion-reading charity operating across the Sunshine Coast to help primary school children improve their literacy and confidence. By pairing young students who are struggling or hesitant with calm, accredited dogs, the program creates a safe, judgment-free space where reading transforms into a fun and relaxing activity.",
    category: "Education & Therapy",
    website: "https://www.storydogs.org.au/",
    instagram: "https://www.instagram.com/storydogs.org.au/",
    facebook: "https://www.facebook.com/storydogs"
  },
  {
    id: 2,
    name: "Australasian Conservation Dog Network",
    description: "Specially trained dogs that help protect endangered wildlife",
    fullDescription: "The Australasian Conservation Dog Network (ACDN) is the primary collaborative hub for professionals using detection dogs in Australia. It connects researchers, handlers, and conservationists to promote the ethical, evidence-based use of scent-detection dogs for wildlife tracking, invasive species control, and ecological research.",
    category: "Conservation",
    website: "https://conservationdognetwork.com.au/"
  },
  {
    id: 3,
    name: "Ninja's Trust",
    description: "Supporting retired police dogs in their golden years",
    fullDescription: "Ninja's Trust is an Australian non-profit charity dedicated to supporting the health, welfare, and dignity of retired police dogs. The organization is named in honor of Ninja, a brave Australian Federal Police (AFP) dog who passed away after serving the community for 7 years.",
    category: "Law Enforcement",
    website: "https://www.ninjastrust.org.au"
  },
  {
    id: 5,
    name: "Canine Refined Assistance Dog Training",
    description: "Training assistance dogs for people with various disabilities",
    fullDescription: "Canine Refined is a Brisbane-based assistance dog training service dedicated to helping handlers train Guide, Hearing And Assistance dogs. Led by Lauren Toone, a certified trainer and former disability support worker, the organization focuses on helping teams satisfy the needs of those who need help.",
    category: "Assistance",
    website: "https://www.caninerefined.com.au/"
  }
];

export const vendors = [
  {
    id: 1,
    name: "On the Go Espresso",
    category: "Coffee",
    description: "Premium mobile coffee service"
  },
  {
    id: 2,
    name: "Sausage Sizzle - TWCC",
    category: "Food",
    description: "Classic Australian sausage sizzle"
  },
  {
    id: 3,
    name: "Hugo's Dog Ice Cream",
    category: "Treats",
    description: "Dog-friendly ice cream treats"
  },
  {
    id: 4,
    name: "Pet Junction",
    category: "Retail",
    description: "Toys, treats, and pet accessories"
  }
];

export const otherServices = [
  {
    id: 1,
    name: "Vet Services",
    provider: "Bli Bli Vet & AES Emergency",
    description: "On-site veterinary support"
  },
  {
    id: 2,
    name: "Grooming",
    provider: "Mobile Dog Groomer",
    description: "Professional dog grooming services"
  },
  {
    id: 3,
    name: "Photography — Capture the Memories",
    provider: "Emma Nayler",
    description: "Professional onsite event and pet photography. Capture those special moments with your furry friend — complimentary portraits available on the day."
  },
  {
    id: 4,
    name: "Education",
    provider: "Toad Busters",
    description: "Educational sessions about local wildlife"
  }
];

export const competitions = [
  {
    id: 1,
    name: "Twin Waters Everyday Heroes",
    description: "Not all heroes wear capes—some have paws. Our Everyday Dog Hero Contest celebrates the dogs who make a difference in the quiet, meaningful ways that matter most. This is your chance to share the story of your dog and why they are your personal hero.",
    fullDescription: "Whether they've helped you through a difficult time, bring daily comfort and companionship, protect your family, or simply fill your life with unconditional love and joy—every story matters. We invite community members to submit a short entry telling us what makes their dog an everyday hero. A Story Wall will be featured at the event sharing all the community hero stories submitted and selected stories will be shared by the MC during the event. Because sometimes, the smallest acts of love leave the biggest pawprints.",
    entryFee: "Free",
    prizes: "Submit Your Candidate for TWRA Everyday Hero",
    submitEmail: "paws@twra.net",
    categories: []
  },
  {
    id: 2,
    name: "Best Dog Dad (Father's Day)",
    description: "The TWRA annual Paws in the Park event is being held on Father's Day this year, so we decided it was a great opportunity to also celebrate the incredible bond between dogs and their devoted dads.",
    fullDescription: "Our Best Dog Dad Contest recognises the men who go above and beyond for their four-legged companions—the early morning walkers, the treat givers, the trainers, the protectors, and the ones who never say no to 'just one more cuddle.' Whether he's teaching new tricks, planning daily adventures, or simply being your dog's favourite human, this is your chance to give a well-deserved shoutout to an amazing dog dad. Nominate yourself, a partner, friend, neighbour or a family member and tell us why they deserve the title of TWRA's Best Dog Dad.",
    howToEnter: "Know an amazing dog dad? Enter him in the TWRA Dog Dad contest by: Your entry should include the dog dad's name (and dog's name), a short story (approx. 100–250 words) about what makes him a great dog dad, and a photo of the dog dad and their pup.",
    entryFee: "Free",
    prizes: "Winners will be announced at the event with special recognition",
    categories: []
  },
  {
    id: 3,
    name: "Musical Sits",
    description: "A fun twist on musical chairs for dogs and their owners",
    entryFee: "Free",
    prizes: "Winner takes all prize pool"
  },
  {
    id: 4,
    name: "Red Light Green Light",
    description: "Test your dog's obedience skills in this exciting challenge",
    entryFee: "Free",
    prizes: "Medals and treats"
  },
  {
    id: 5,
    name: "Paws of Purpose Costume Parade",
    description: "Step into the spotlight and celebrate what makes your dog truly special in our Paws of Purpose themed Costume Parade!",
    fullDescription: "This year, we're inviting all participants to dress their dogs (and themselves, if they wish!) to reflect the unique 'purpose' they bring to our lives and community. Whether your dog is a loyal companion, a brave protector, a playful entertainer, or simply your everyday hero, this is your chance to showcase their personality, story, and impact. From service and therapy-inspired costumes to creative representations of love, friendship, and fun, the parade is all about celebrating the meaningful roles dogs play—big and small.",
    whatItMeans: "Every dog has a purpose. For some, it's providing comfort or protection. For others, it's bringing joy, laughter, and companionship into our daily lives.",
    costumeIdeas: [
      "A real-life role (e.g. police, fire and rescue, medical and therapy)",
      "A superhero (e.g. Thor, Wonder Woman, Batman)",
      "Your dog's personality (e.g. 'Senior Sidekick', 'Exercise Coach')",
      "A creative or symbolic 'purpose' (e.g. spreading happiness, community spirit)"
    ],
    judgingCriteria: [
      "Creativity and originality",
      "Connection to the Paws of Purpose theme",
      "Effort and presentation",
      "The story behind the costume"
    ],
    entryFee: "Free",
    prizes: "Bonus points for matching outfits or team participation!",
    categories: []
  },
  {
    id: 6,
    name: "Paws of Purpose Kids Colouring Contest",
    description: "Calling all young dog lovers! Join our Kids Colouring Competition and show us your most colourful canine creations for a chance to win a prize.",
    fullDescription: "We're inviting young artists to bring their love of dogs to life with colour, imagination, and creativity. Kids will receive a special themed colouring sheet inspired by our Paws of Purpose celebration—featuring four-legged heroes in one of their wonderful roles. Whether it's a bright and bold masterpiece or a carefully coloured creation, every entry is a chance to celebrate the joy, friendship, and happiness dogs bring into our lives. Prizes will be awarded for standout entries, and all participants will have the chance to proudly display their artwork on the day.",
    howToEnter: "Pick up a colouring sheet at the event (or download in advance), get creative with your colours and designs, and submit your masterpiece by [insert time].",
    entryFee: "Free",
    prizes: "Winners will be announced during the event!",
    categories: []
  }
];

export const activities = [
  "Photo Booth with Caricaturist",
  "Raffle Draw with exciting prizes",
  "Educational demonstrations by service groups",
  "Live music and entertainment",
  "Dog-friendly activities and play areas"
];

export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_comp-central-1/artifacts/z3ho2o1e_9D9FF293-9868-439C-89AB-17535414297D_1_105_c.jpeg",
    caption: "Best in denim — pure smiles and the sweetest hat at the Costume Parade"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_comp-central-1/artifacts/pd8i8286_4737F74C-442E-4DEC-A103-75A346ACAF41_1_105_c.jpeg",
    caption: "Our committee at work — Paws in the Park volunteers running the day"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_comp-central-1/artifacts/48dn3cif_BA3C08D0-5BD7-402B-8C2D-6BC95CCB2E2F_1_105_c.jpeg",
    caption: "Christmas surfer pup — a white dog in elf surfer costume stealing the show"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_comp-central-1/artifacts/4zma9rsn_3B1A4A20-264C-472A-97EE-0B2A23B71ED9_1_105_c.jpeg",
    caption: "Royalty on four paws — a regal red-velvet winner with handler"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_comp-central-1/artifacts/3wytwaok_5D756C71-201F-4C5E-9AB3-E88A818A7C6B_1_105_c.jpeg",
    caption: "Costume Parade lineup — proud handlers and pups in full regalia"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_comp-central-1/artifacts/903k8kl2_2B6A3ACB-78EC-4CA0-A0CB-8C7AA66690DF_1_105_c.jpeg",
    caption: "Vendor village in full swing — Story Dogs and Canine Perspective stalls"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_comp-central-1/artifacts/jzru71jh_D52696B5-E50E-4AB2-9A95-D31F11C6D145_1_201_a.jpeg",
    caption: "Sunshine Coast Council's Responsible Pet Ownership stall"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_comp-central-1/artifacts/0hl67p5b_E7F1C4A2-50CE-45E6-9580-4A6BBDC773B8_1_105_c.jpeg",
    caption: "Story Dogs volunteers with their accredited reading companions"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_comp-central-1/artifacts/pbubby4o_B9E2B441-A0E8-4BCF-B12A-5A3013ECF0E0_1_105_c.jpeg",
    caption: "Sweetest peapod in pink — a costume that stole the day"
  },
  {
    id: 10,
    url: "https://customer-assets.emergentagent.com/job_comp-central-1/artifacts/ph6simjm_5709A615-49D1-4EBD-BF90-C5FFFB4C27E6_1_105_c.jpeg",
    caption: "Ringside grins — a proud handler with her spaniel in team colours"
  },
  {
    id: 11,
    url: "https://customer-assets.emergentagent.com/job_comp-central-1/artifacts/mfyv3u7e_47D959CD-D0F6-4369-8AAA-1CA8B0E065F8_1_105_c.jpeg",
    caption: "The TWRA marquee, proudly supported by Fiona Simpson MP"
  },
  {
    id: 12,
    url: "https://customer-assets.emergentagent.com/job_comp-central-1/artifacts/l6erf9iq_C7B53FB4-E10C-45C5-B9E5-635EAA2BB783_1_105_c.jpeg",
    caption: "Local author Donna Hamer at her Pet Loss & Grief stall"
  },
  {
    id: 13,
    url: "https://customer-assets.emergentagent.com/job_comp-central-1/artifacts/ciy2u8fw_5E0A3DEC-D1E1-4423-9600-F7D17055736A_1_105_c.jpeg",
    caption: "Our amazing volunteers keeping the day running smoothly"
  },
  {
    id: 14,
    url: "https://customer-assets.emergentagent.com/job_comp-central-1/artifacts/e7jy5pyu_1000012434.jpg",
    caption: "An angel on the grass — Westie in angel wings at Paws in the Park"
  },
  {
    id: 15,
    url: "https://customer-assets.emergentagent.com/job_comp-central-1/artifacts/6j83625y_DSC_5878-2048x1254.jpg",
    caption: "Last year's Paws in the Park Sub Committee 2025 at Moorings Park"
  },
  {
    id: 16,
    url: "https://customer-assets.emergentagent.com/job_comp-central-1/artifacts/d6q712h1_1A119A12-E220-49D6-B71F-A8F57DCE356A_1_105_c.jpeg",
    caption: "A handsome Airedale Terrier striking a pose at the event"
  },
  {
    id: 17,
    url: "https://customer-assets.emergentagent.com/job_comp-central-1/artifacts/dcl6il96_1F67C3A7-79F2-4F35-A462-8FABC31D9414_1_105_c.jpeg",
    caption: "Mid-flight! A Border Collie soaring through the agility course"
  },
  {
    id: 18,
    url: "https://customer-assets.emergentagent.com/job_comp-central-1/artifacts/xyqydv7v_Screenshot_20250811_130149_Gmail.jpg",
    caption: "The Paws in the Park Committee with their canine companions"
  },
  {
    id: 19,
    url: "https://customer-assets.emergentagent.com/job_comp-central-1/artifacts/8o30oprl_20250810_110134.jpg",
    caption: "Vendor tents and community stalls at Paws in the Park 2025"
  },
  {
    id: 20,
    url: "https://customer-assets.emergentagent.com/job_comp-central-1/artifacts/mdpdo9t1_20250810_110208.jpg",
    caption: "Competition winner celebrating with their golden retriever"
  },
  {
    id: 21,
    url: "https://customer-assets.emergentagent.com/job_comp-central-1/artifacts/s6jmtofv_20250810_110217.jpg",
    caption: "Crowds enjoying the vendor village and community activities"
  },
  {
    id: 22,
    url: "https://customer-assets.emergentagent.com/job_comp-central-1/artifacts/caovn3wc_20250810_113738.jpg",
    caption: "Fun activities and games area for all ages"
  },
  {
    id: 23,
    url: "https://customer-assets.emergentagent.com/job_comp-central-1/artifacts/bol647d4_20250810_113753.jpg",
    caption: "Creative costumes at the Paws of Purpose Costume Parade"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    text: "Such a wonderful community event! My kids and our golden retriever had an amazing time.",
    avatar: "SJ"
  },
  {
    id: 2,
    name: "Mark Thompson",
    text: "Great organization and fantastic to see all the hero dogs being celebrated.",
    avatar: "MT"
  },
  {
    id: 3,
    name: "Lisa Chen",
    text: "The competitions were so much fun! Can't wait for next year's event.",
    avatar: "LC"
  }
];
